var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonAddOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.678,
    height: 50.226,
    viewBox: "0 0 61.678 50.226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#00b9ff;stroke-width:4px;}.a{stroke-linecap:round;stroke-linejoin:round;}.b{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, -0.017, 0.017, 1, -31.195, -44.749)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M199.757,59.353a12.357,12.357,0,0,0,24.631,0c.56-6.5-4.9-11.353-12.316-11.353S199.2,52.967,199.757,59.353Z",
    transform: "translate(-155.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M120.036,304c10.9,0,21.954,6.718,24,19.4.25,1.528-.527,2.995-1.96,2.995H97.994c-1.433,0-2.207-1.467-1.96-2.995C98.082,310.718,109.14,304,120.036,304Z",
    transform: "translate(-63.989 -232.879)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.837,176v15.674M32,183.837H47.674",
    transform: "translate(41.847 -115.436)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAddOutlineIcon);
export default __webpack_public_path__ + "static/media/person-add-outline-icon.4ad63e09fb420025231a25e93f2bcabf.svg";
export { ForwardRef as ReactComponent };